export default {
  Manitoba() {
    const MB = {
      message: "The :attribute must be valid Manitoba postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Rr]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return MB;
  },
  Alberta() {
    const AB = {
      message: "The :attribute must be valid Alberta postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Tt]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return AB;
  },
  NewfoundlandAndLabrador() {
    const NL = {
      message:
        "The :attribute must be valid Newfoundland And Labrador postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Aa]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return NL;
  },
  PrinceEdwardIsland() {
    const PE = {
      message: "The :attribute must be valid Prince Edward Island postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Cc]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return PE;
  },
  NovaScotia() {
    const NS = {
      message: "The :attribute must be valid Nova Scotia postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Bb]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return NS;
  },
  Quebec() {
    const QC = {
      message: "The :attribute must be valid Quebec postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[GgJjHh]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return QC;
  },
  NewBrunswick() {
    const NB = {
      message: "The :attribute must be valid New Brunswick postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Ee]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return NB;
  },
  Ontario() {
    const ON = {
      message: "The :attribute must be valid Ontario postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[PpLlKkNn]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return ON;
  },
  Saskatchewan() {
    const SK = {
      message: "The :attribute must be valid Saskatchewan postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Ss]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return SK;
  },
  BritishColumbia() {
    const BC = {
      message: "The :attribute must be valid British Columbia postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Vv]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return BC;
  },
  Yukon() {
    const YT = {
      message: "The :attribute must be valid Yukon postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Yy]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return YT;
  },
  NorthwestTerritories() {
    const NT = {
      message: "The :attribute must be valid Northwest Territories postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Xx]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return NT;
  },
  Nunavut() {
    const NU = {
      message: "The :attribute must be valid Nunavut postal code",
      rule: (val, params, validator) => {
        return validator.helpers.testRegex(
          val,
          /^[Xx]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
        );
      },

      required: true, // optional
    };
    return NU;
  },
};
